import { s360ConfigService } from "./S360Config";
import HWUser from "../HWLibrary/HWUser";

const watchForChatSDKEvents = (appComponent, onDateRefresh, onConfigUpdate) => {
  window.addEventListener(
    "message",
    (messageEvent) => {
      try {
        let messageData = JSON.parse(messageEvent.data);

        switch (messageData.action) {
          case "on-config-data-update":
            s360ConfigService.setConfig(messageData.data);
            onConfigUpdate();
            break;
          case "on-reset-user":
            onResetUser(onDateRefresh);
            break;
          case "on-set-user-config":
            s360ConfigService.setUserConfig(messageData.data);
            break;
          case "on-coach-screen":
            coachScreenOpen();
            break;
          case "on-coach-screen-close":
            coachScreenClose();
            break;
          default:
            break;
        }
      } catch (error) {
        console.log("Invalid Message Data: ");
      }

      appComponent.setState({ refreshKey: new Date().toISOString() });
    },
    false
  );
};

const onResetUser = (onDateRefresh) => {
  HWUser.resetUser();
  onDateRefresh && onDateRefresh();
  window.location.reload();
};

const postPlatformMessage = (messageData, actionName) => {
  let message = {
    data: messageData,
    action: actionName,
    clientHostId: s360ConfigService.clientHostId,
  };
};

const fetchConfigDetailsFromClientHost = () => {
  postPlatformMessage(null, "update-client-host-config");
};

const sendOnAppOpen = () => {
  postPlatformMessage(null, "on-app-open");
};

const sendOnAppClose = () => {
  postPlatformMessage(null, "on-app-close");
};
const coachScreenOpen = () => {
  postPlatformMessage(null, "on-coach-screen");
};

const coachScreenClose = () => {
  postPlatformMessage(null, "on-coach-screen-close");
};
export {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
  sendOnAppOpen,
  sendOnAppClose,
  coachScreenOpen,
  coachScreenClose,
};
